import { getActiveNotifications } from "@/utils/api.js";
import { defineStore } from "pinia";

export const defaultState = () => ({
    notifications : [], // array of objects
    fetched: false,
});

const _FLUX_NOTIF_LOCALSTORAGE = "flux-notify-settings" // key for localstorage

export const useActiveNotificationsStore = defineStore("active_notifications", {
    state: defaultState,
    actions: {
        async initializeActiveNotificationsStore() {
            // sort this.notifications by the message priority, the high should be on top, medium, then low
            const priorityOrder = { high: 1, medium: 2, low: 3 };
            this.notifications = (await getActiveNotifications()).sort((a, b) => {
                return priorityOrder[a.priority] - priorityOrder[b.priority];
            });
            
            // get all the hidden notifications from the browser storage
            const mySettings = JSON.parse(localStorage.getItem(_FLUX_NOTIF_LOCALSTORAGE))
            if( mySettings?.hide_id ) {
                this.notifications.forEach(notification => {
                    if(mySettings.hide_id.includes(notification.id)) {
                        notification.hidden = true;
                    }
                });
            }
            this.fetched = true
        },
        hideNotification(id) {
            let mySettings = JSON.parse(localStorage.getItem(_FLUX_NOTIF_LOCALSTORAGE))
            if(!mySettings) {
                mySettings = {hide_id: []}
            }
            this.notifications.forEach(notification => {
                if (notification.id == id) {
                    notification.hidden = true;
                    mySettings.hide_id.push(id);
                }
            })
            localStorage.setItem(_FLUX_NOTIF_LOCALSTORAGE, JSON.stringify(mySettings));
        },
        clear() {
            this.$reset();
        }
    },
});
